import React from 'react';

import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type IndustryItem = {
  industryId: string;
  industryName: string;
};

type IndustryChipsProps = {
  /** 業界一覧 */
  industries: IndustryItem[];
  /** 空の場合に表示するテキスト */
  emptyText?: string;
};

/**
 * 業界をChip一覧で表示する共通コンポーネント。
 * プロジェクト詳細等で利用する。
 */
const IndustryChips: React.FC<IndustryChipsProps> = ({ industries, emptyText = '-' }) => {
  if (!industries || industries.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        {emptyText}
      </Typography>
    );
  }

  return (
    <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
      {industries.map((i) => (
        <Chip
          key={i.industryId}
          label={i.industryName}
          size="small"
          variant="outlined"
          sx={{ borderRadius: 1.5 }}
        />
      ))}
    </Stack>
  );
};

export default IndustryChips;
